import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../hooks/useMetaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg' | 'xl';
  href?: string;
  className?: string;
}
export function CtaButton({
  children,
  variant = 'primary',
  size = 'lg',
  href = '#planes',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-3 rounded-2xl text-center font-display font-extrabold uppercase tracking-tight transition-[transform,background-color,box-shadow,color] duration-150 ease-calm focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-gold-300 active:translate-y-px';
  const sizes = {
    md: 'px-6 py-3.5 text-sm',
    lg: 'px-8 py-4 text-base md:text-lg',
    xl: 'px-8 py-5 text-lg md:text-2xl'
  };
  const variants = {
    primary: 'bg-gold-500 text-ink shadow-lift hover:bg-gold-400',
    secondary: 'bg-white text-blue-700 ring-2 ring-inset ring-gold-300 hover:bg-gold-50'
  };
  const isCheckout = href.startsWith('http');
  const handleClick = () => {
    if (isCheckout) {
      trackPixelEvent('InitiateCheckout', {
        content_name: 'MegaPack BIO-RESET 5.0',
        value: 19990,
        currency: 'ARS'
      });
    }
  };
  return <a href={href} onClick={handleClick} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-71" data-mp="3jxyr5zly9l5l">
      <span data-id="element-72" data-mp="3otxo4blcgbhm">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-calm group-hover:translate-x-1 md:h-6 md:w-6" aria-hidden="true" data-id="element-73" data-mp="3sxdh8xy7ftpk" />
    </a>;
}